import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localizedFormat);
dayjs.extend(utc);

export function formatCreatedAt(date: string) {
  const parsed = dayjs.utc(date);
  return `${parsed.local().format('YYYY-MM-DD')} @ ${parsed.local().format('HH:mm:ss')}`;
}

export const formatDate = (date: string, format?: string) => dayjs(date).format(format ?? 'll');
export const formatCreatedAtToDate = (date: string) => dayjs.utc(date).local().format('ll');
export const formatCreatedAtToMinutes = (date: string) => dayjs.utc(date).local().format('D MMM, YYYY HH:mm');

export function formatCreatedAtWithTimeZone(date: string) {
  const parsed = dayjs.utc(date);
  return `${parsed.local().format('YYYY-MM-DD')} ${parsed.local().format('HH:mm:ss')} GMT${parsed
    .local()
    .format('Z')}`;
}

export const parse = (str: string) => dayjs(str);

export const sortByDate = (a: string, b: string) => {
  const dateA = parse(a);
  const dateB = parse(b);

  if (dateA > dateB) return 1;
  if (dateA < dateB) return -1;
  return 0;
};
